import Event from '@oppobrowser/lib-browser-event';
import template from './index.dot';
import { v4 as uuidv4 } from 'uuid';
import './index.scss';
import { $$ } from '@js/utils';
import { isBrowserVersionHigherThan, getEngine } from '../../js/utils';
import Feedback from '../../js/feedback.js';
import {
  getSearchData as getData,
  exposeRelatedNewsStat as exposeReport,
  clickReportStat as clickReport,
} from './js/feeds-relatedSearch.umd';

const EventHandler = {
  jumpSearchPage(node, event) {
    setTimeout(() => {
      node.classList.add('searchs__item__visited');
      event.stopPropagation();
      const index = node.dataset.index;
      const item = this.data.data.querys[index].query;
      const jumpUrl = this.data.data.querys[index].jumpUrl;
      const jumpEngine = this.data.data.querys[index].jumpEngine;

      const data = {
        pos: index,
        title: item,
        link: this.data.link,
        transparent: this.data.transparent,
        algSource: this.data.algSource,
      };
      const docInfo = {
        source: this.docinfo.source,
      };
      // 前端埋点
      clickReport(data, docInfo);

      // 定义点击相关搜索jsapi参数
      const params = { pos: index };
      // 7.32新增的方法clickRelativeSearchByQuery，存在jumpUrl则调用老的clickRelativeSearch方法，否则采用新的方法
      if (
        window.wv &&
        wv.isMethodValid('BrowserIFlow.clickRelativeSearchByQuery')
      ) {
        if (jumpUrl) {
          params.url = jumpUrl;
        } else {
          params.query = item;
          params.jumpEngine = jumpEngine;
          params.search_id = this.searchId;
          window.wv.invoke('BrowserIFlow.clickRelativeSearchByQuery', params);
          return;
        }
      } else if (
        window.wv &&
        wv.isMethodValid('BrowserIFlow.clickRelativeSearch')
      ) {
        params.url =
          this.data.link && this.data.link.replace('{searchTerms}', item);
      } else {
        const url =
          this.data.link && this.data.link.replace('{searchTerms}', item);
        location.href = url;
        return false;
      }
      params.search_id = this.searchId;
      window.wv.clickRelativeSearch(JSON.stringify(params));
    }, 200);
  },
};

export default class RelatedSearch {
  constructor(el, name, data = {}) {
    this.el = el;
    this.data = {};
    this.isReport = false;
    (this.searchId = ''), (this._eventHandler = {});
    this.docinfo = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });

    this.docinfo = window.pageData.DOCINFO;

    // 初始化生成search_id
    this.searchId = uuidv4();
    this._bindEvent();
    this.searchInit();
    this.getSearchData();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  async getSearchData() {
    const params = {
      source: this.docinfo.source,
      title: this.docinfo.title,
      keywords: this.docinfo.keywords,
      out_id: this.docinfo.media.outId,
    };
    this.data = await getData(params);

    if (process.env.NODE_ENV === 'development') {
      this.data = {
        code: 0,
        data: {
          title: '相关搜索',
          querys: [
            { query: '明星在镜头前哭' },
            { query: '镜头前有感觉' },
            { query: '明星在镜头前哭' },
            { query: '光圈系数越大光孔口径越大' },
            { query: '在二度空间里只有长度和宽度' },
          ],
        },
        engine: 'toutiao',
        link: 'https://so.toutiao.com/search?keyword={searchTerms}&pd=synthesis&traffic_source=CS1113&original_source=21&source=client',
      };
    }
    if (this.data && this.data.code == 0) {
      this.render();
    }
  }

  searchInit() {
    //客户端返回结果为空时，提供方法供客户端调用，获取搜索查询词
    window.IFlowWebPage = {};
    let that = this;
    window.IFlowWebPage.onRelativeSearchDataLoaded = function (data) {
      if (that.data.length > 0) {
        return;
      }
      that.data = data;
      that.render();
    };
  }

  exposeRelatedNewsStat() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((item) => {
        if (item && item.isIntersecting && !this.isReport) {
          const docInfo = {
            source: this.docinfo.source,
            title: this.docinfo.title,
          };
          exposeReport(this.data, docInfo);
          this.isReport = true;

          observer.disconnect();
        }
      });
    });
    let newArr = Array.from(document.querySelectorAll('.searchs__title'));
    newArr.forEach((item) => observer.observe(item));
  }

  render() {
    const { data } = this;
    this.el.innerHTML = template({
      dataList: data.data?.querys || [],
    });
    this.exposeRelatedNewsStat();
    const FeedbackBtns = $$('.searchs__item', this.el);
    FeedbackBtns.map((el) => new Feedback(el));
  }

  sendDataToBrowser() {
    //  8.6新增  透传相关搜索词信息给客户端
    if (window.wv && wv.isMethodValid('BrowserIFlow.sendData')) {
      if (JSON.stringify(this.data) === '{}') {
        window.wv.invoke('BrowserIFlow.sendData', ['relSearchWordInfo', '']);
      } else {
        const data = { words: [], algSource: this.data.algSource };
        this.data.data.querys.forEach((item) => {
          data.words.push({
            word: item.query,
            jumpUrl: item.jumpUrl,
            jumpEngine: item.jumpEngine ? item.jumpEngine : getEngine(),
          });
        });
        window.wv.invoke('BrowserIFlow.sendData', [
          'relSearchWordInfo',
          JSON.stringify(data),
        ]);
      }
    }
  }
}
